import { useOpenModal } from '@modusign/design-system';
import { useGetUserInfo, useGetUserInvitation } from '@modusign/openapi-client-user';
import moment from 'moment';
import { useEffect } from 'react';

import InvitationAcceptanceModal from '@app/features/workspaceManagement/workspaceMemberInvitation/components/InvitationAcceptanceModal';

export default function useInvitationAcceptanceModal() {
  const openModal = useOpenModal();

  const { data: userInvitation, isSuccess: isUserInvitationFetchSuccess } = useGetUserInvitation({
    query: {
      staleTime: 1000,
      refetchOnWindowFocus: false,
    },
  });
  const { data: user, isSuccess: isUserFetchSuccess } = useGetUserInfo();

  useEffect(() => {
    if (
      isUserInvitationFetchSuccess &&
      isUserFetchSuccess &&
      userInvitation?.status === 'ONGOING' &&
      // 웰컴 모달 배포 후에 인증했는데 웰컴 설문을 완료하지 않은 유저에게는 초대장 모달을 띄우지 않는다.
      !(
        user.activatedAt &&
        moment(user.activatedAt).isAfter('2023-09-23') &&
        !user.profile.survey?.userType
      )
    ) {
      openModal(({ isOpen, onClose }) => (
        <InvitationAcceptanceModal isOpen={isOpen} onClose={onClose} />
      ));
    }
  }, [
    isUserFetchSuccess,
    isUserInvitationFetchSuccess,
    openModal,
    user?.activatedAt,
    user?.profile.survey?.userType,
    userInvitation?.status,
  ]);
}
